module.exports = __webpack_public_path__ + "img/ic_cloud.1a8259e7.svg";